<span matSnackBarLabel class="flex gap-4 items-center">
    <div
        class="min-w-14 min-h-14 w-14 h-14 flex justify-center items-center rounded-full bg-(--mat-sys-inverse-primary) text-(--mat-sys-inverse-surface)">
            <mat-icon class="icon-filled">auto_towing</mat-icon>
    </div>
    <div class="flex flex-col">
        <span class="mat-font-label-lg text-(--mat-sys-inverse-primary)">
            {{message.notification?.title ?? 'Notificación'}}
        </span>
        <span>
            {{message.notification?.body ?? 'Nuevo mensaje'}}
        </span>
    </div>

    <span matSnackBarActions class="justify-end">
        <button matButton matSnackBarAction (click)="snackBarRef.dismissWithAction()">Cerrar</button>
    </span>
</span>